// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"9e4e135a","745":"40620c20"}[chunkId] + ".chunk.js";
};